export const addOrder = (order) => {
  return {
    type: 'ADD_ORDER',
    payload: order,
  }
}

export const finalizeOrder = (order) => {
  return {
    type: 'FINALIZE_ORDER',
    payload: order,
  }
}

export const resetMovedTripId = () => {
  return {
    type: 'RESET_MOVED_TRIP_ID',
  }
}

export const resetLoadingAnimation = (tripId) => {
  return {
    type: 'RESET_LOADING_ANIMATION',
    payload: tripId,
  }
}

export const initOrders = (orders) => {
  return {
    type: 'INIT_ORDERS',
    payload: orders,
  }
}

export const updateSingleOrder = (order, filter, filterItOut = false, allowInsert = false) => {
  return {
    type: 'UPDATE_SINGLE_ORDER',
    payload: { order, filter, filterItOut, allowInsert },
  }
}

export const addOrders = (orders) => {
  return {
    type: 'ADD_ORDERS',
    payload: orders,
  }
}

export const updateIncidentOrder = (orderId) => {
  return {
    type: 'UPDATE_INCIDENT_ORDER',
    payload: orderId,
  }
}

export const addOnlineDrivers = (drivers) => {
  return {
    type: 'ADD_ONLINE_DRIVERS',
    payload: drivers,
  }
}

export const addOnlineDriver = (driver) => {
  return {
    type: 'ADD_ONLINE_DRIVER',
    payload: driver,
  }
}

export const removeOnlineDriver = (driver) => {
  return {
    type: 'REMOVE_ONLINE_DRIVER',
    payload: driver,
  }
}

export const updateDriverLocation = (driver) => {
  return {
    type: 'UPDATE_DRIVER_LOCATION',
    payload: driver,
  }
}

export const updateEtaInDriver = (orderId, eta) => {
  return {
    type: 'UPDATE_ETA_IN_DRIVER',
    payload: { orderId, eta },
  }
}

export const updateEtaInOrder = (orderId, eta) => {
  return {
    type: 'UPDATE_ETA_IN_ORDER',
    payload: { orderId, eta },
  }
}

export const showIconAnimationInOrder = (orderId) => {
  return {
    type: 'SHOW_ICON_ANIMATION_IN_ORDER',
    payload: { orderId },
  }
}

export const roomSuccess = (room) => {
  return {
    type: 'ROOM_SUCCESS',
    payload: room,
  }
}

export const roomLoadMoreSuccess = (rooms) => {
  return {
    type: 'ROOM_LOAD_MORE_SUCCESS',
    payload: rooms,
  }
}

export const roomClear = () => {
  return {
    type: 'ROOM_CLEAR',
  }
}

export const roomError = (error) => {
  return {
    type: 'ROOM_ERROR',
    error,
  }
}

export const messageSuccess = (message) => {
  return {
    type: 'MESSAGE_SUCCESS',
    payload: message,
  }
}

export const messageLoadMore = (message) => {
  return {
    type: 'MESSAGE_LOAD_MORE',
    payload: message,
  }
}

export const messageError = (error) => {
  return {
    type: 'MESSAGE_ERROR',
    error,
  }
}

export const updateDriverStatus = (driver) => {
  return {
    type: 'DRIVER_STATUS_UPDATED',
    payload: driver,
  }
}

export const changeRoomOnNewMessage = (newMessage) => {
  return {
    type: 'ROOM_CHANGE_ON_MESSAGE',
    payload: newMessage,
  }
}

export const sendNewMessage = (newMessage) => {
  return {
    type: 'SEND_NEW_MESSAGE',
    payload: newMessage,
  }
}

export const messageUpdate = (message) => {
  return {
    type: 'MESSAGE_UPDATE',
    payload: message,
  }
}

export const roomMessageUnread = (room_id) => {
  return {
    type: 'ROOM_MESSAGE_UNREAD',
    payload: room_id,
  }
}

export const setActiveRoom = (room_id) => {
  return {
    type: 'SET_ACTIVE_ROOM',
    payload: room_id,
  }
}

export const setActiveRoomDriverInfo = (driverInfo) => {
  return {
    type: 'SET_ACTIVE_ROOM_DRIVER_INFO',
    payload: driverInfo,
  }
}

export const setInActiveRoom = () => {
  return {
    type: 'SET_INACTIVE_ROOM',
  }
}

export const updateFilter = (filter) => {
  return {
    type: 'UPDATE_FILTER',
    payload: filter,
  }
}

export const updateTopbarFilter = (filter) => {
  return {
    type: 'UPDATE_TOPBAR_FILTER',
    payload: filter,
  }
}

export const updateSearchValue = (value) => {
  return {
    type: 'UPDATE_SEARCH_VALUE',
    payload: value,
  }
}

export const addSosDriver = (driver) => {
  return {
    type: 'ADD_SOS_DRIVERS',
    payload: driver,
  }
}

export const removeSosDriver = (driver) => {
  return {
    type: 'REMOVE_SOS_DRIVERS',
    payload: driver,
  }
}

export const addSosClients = (clients) => {
  return {
    type: 'ADD_SOS_CLIENTS',
    payload: clients,
  }
}

export const addSosClient = (client) => {
  return {
    type: 'ADD_SOS_CLIENT',
    payload: client,
  }
}

export const removeSosClient = (client) => {
  return {
    type: 'REMOVE_SOS_CLIENTS',
    payload: client,
  }
}

export const updateSosClient = (client) => {
  return {
    type: 'UPDATE_SOS_CLIENT_LOCATION',
    payload: client,
  }
}

// SELECTED MAP DIRECTIONS
export const selectRoute = (route) => {
  return {
    type: 'SELECT_ROUTE',
    payload: route,
  }
}

export const hideRouteMap = () => {
  return {
    type: 'HIDE_ROUTE_MAP',
  }
}

// MESSAGE UNREAD COUNT
export const setTotalUnread = (count) => {
  return {
    type: 'SET_TOTAL_UNREAD',
    payload: count,
  }
}

export const manageRoom = (payload) => {
  return {
    type: 'MANAGE_ROOM',
    payload,
  }
}

export const newMessageAddCount = (count) => {
  return {
    type: 'NEW_MESSAGE_ADD_COUNT',
    payload: count,
  }
}

export const removeTotalUnread = () => {
  return {
    type: 'REMOVE_TOTAL_UNREAD'
  }
}

export const updateChannelUnreadCount = ({
  channelId,
  totalReadCount
}) => {
  return {
    type: 'UPDATE_CHANNEL_UNREAD_COUNT',
    payload: {
      channelId,
      totalReadCount
    }
  }
}

export const readMultipleMessages = ({
  channelId,
  messageIds,
}) => {
  return {
    type: 'READ_MULTIPLE_MESSAGES',
    payload: {
      channelId,
      messageIds
    }
  }
}

// Hide animation when click to chat icon or navigate to chat app.
export const animationHide = () => {
  return {
    type: 'ANIMATION_HIDE'
  }
}